import { getLevelDescription, getLevelLabel, getLevelTitle } from '@app/src/pages/Assessments/Assessment/utils'
import type Assessment from '@app/src/types/assessment'
import { AssessmentLevelNamesType, AssessmentType } from '@app/src/types/resourceExplorer'
import { getLevelThresholdRanges } from '@app/src/utils/assessmentLevels'
import { LabelFormat } from '@app/src/utils/assessmentLevelTranslations'
import type { IntlFormatters } from 'react-intl'

export interface AssessmentLevelTexts {
  label: string
  thresholdText: string
  description: string
}

export const getAssessmentLevelTexts = (
  assessment: Assessment,
  providerName: string | undefined,
  formatMessage: IntlFormatters['formatMessage'],
): AssessmentLevelTexts => {
  const template = assessment.assessmentTemplate
  const level = assessment.totalLevel ?? 0
  const description = getLevelDescription(level, template, providerName, formatMessage)

  if (template.assessmentType === AssessmentType.BaselineAssessment) {
    return { label: getLevelTitle(level, template, formatMessage), thresholdText: '', description }
  }

  if (!level) return { label: '', thresholdText: '', description }

  const label = getLevelLabel(
    level,
    template.levels ?? 5,
    template.assessmentType,
    template.levelNamesType ?? AssessmentLevelNamesType.Intervals,
    formatMessage,
    LabelFormat.Basic,
  )
  const range = getLevelThresholdRanges(template.levelThresholdPercentages)[level - 1]
  const thresholdText = range
    ? formatMessage({ id: 'assessments.methodology.levelsPercentageInBrackets' }, { from: range.from, to: range.to })
    : ''

  return { label, thresholdText, description }
}
